const getUserFsValue = (user) => user && user.fs;

export { getUserFsValue };
